import React, { useMemo, useState } from "react";
import {
  ContainerHeadline,
  Headline,
  SeriesHeadline,
  TitleCity,
  TitleImg,
  Box,
} from "./BannerCity.styled";

import { JadwalKlasemenContainer } from "../../../../pages/v2/HomeDetails/HomeDetails.styled";
import Card from "../../../atoms/NewCard";
import { usePageContextState } from "../../../../context/PageContext";

import { func } from "../../../../utils";
import analytics from "../../../../utils/analytics";
import Section from "../../../atoms/Section";
import {
  BannerWrapper,
  Container,
  ContentBottom,
  HintScroll,
  PialaByuImg,
  ScrollDownIcon,
} from "../Banner/Banner.styled";
import { Spacer, Text } from "../../..";
import useWindowSize from "../../../../hooks/useWindowSize";
import { useNavigate, useParams } from "react-router-dom";

import { Container as ContainerGrid, Row, Col } from "react-grid-system";

import CardRegister from "../../../atoms/CardRegister";
import moment from "moment";
import BottomSheet from "../../../../pages/v2/FormRegistration/components/BottomSheet/BottomSheet";

const jabarCity = ["subang", "bandung", "garut", "cirebon", "bogor"];

// "Scroll ke bawah" goes precisely to the timeline section, centered so the
// ACTIVE_LINE (center-line) detection marks it active. If a city has no
// timeline, fall back to the first scroll-snap section after the hero, then the
// highlight section.
const handleScroll = () => {
  const hero = document.getElementById("home-detail-banner");
  const nextSnap =
    hero &&
    Array.from(document.querySelectorAll("[id]")).find(
      (el) =>
        !hero.contains(el) &&
        !getComputedStyle(el).scrollSnapAlign.startsWith("none") &&
        hero.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING,
    );
  const target =
    document.getElementById("timeline") ||
    nextSnap ||
    document.getElementById("home-detail-content");
  target?.scrollIntoView({ behavior: "smooth", block: "center" });
};

const BannerCity = ({ data, slug, children }) => {
  const { isLive } = usePageContextState();
  // const handleScroll = () => {
  //   _function.scrollTo("event");
  // };
  const loc = data?.location;
  const city = data?.city || "";
  const event_start_date = data?.event_start_date;
  const event_end_date = data?.event_end_date;
  const regist_url = data?.registration_url;
  const isSameMonthEvent =
    moment(event_start_date).format("MMMM") ===
    moment(event_end_date).format("MMMM");
  const labelStartEvent = moment(event_start_date).format(
    isSameMonthEvent ? "D" : "DD MMMM",
  );
  const eventDate = `${labelStartEvent} - ${moment(event_end_date)?.format("D MMMM")}`;

  const { size } = useWindowSize();
  const navigate = useNavigate();

  // "Nonton Live Streaming": one channel → open it directly; both → "Pilih
  // Channel" sheet (same shell as JadwalCards' "Pilih Kota" popup).
  const channels = [
    { name: "YouTube", url: data?.video_url, logo: "icon/logo-youtube.png" },
    {
      name: "MAXStream",
      url: data?.maxstream_link,
      logo: "icon/logo-maxstream.png",
    },
  ].filter((c) => c.url);
  const [showChannels, setShowChannels] = useState(false);
  const watch = (url) => {
    setShowChannels(false);
    window.open(url, "_blank", "noopener,noreferrer");
  };
  const openLive = () =>
    channels.length > 1 ? setShowChannels(true) : watch(channels[0]?.url);

  const series = jabarCity.includes(city.toLowerCase())
    ? "JAWA BARAT SERIES"
    : "";

  const isSmallScreen = (size?.height || 0) <= 667;
  const isExtraSmallScreen =
    (size?.width || 0) <= 375 && (size?.height || 0) <= 600;
  const isMobileView = (size?.width || 0) <= 830;

  const MobileBanner = () => {
    return (
      <>
        <Container justifyContent={"center"} display={"flex"}>
          {/* <ImgBanner src={func.getStaticImg("bg/banner-kv.png")} alt="kv" /> */}
          <TitleImg
            marginTop={
              isExtraSmallScreen ? "20px" : isSmallScreen ? "25px" : "35px"
            }
            src={func.getStaticImg("illustration/conference/headline-2026.png")}
            alt="title"
            maxWidth={"304px"}
            scale={
              isSmallScreen || isExtraSmallScreen ? "scale(0.8)" : "scale(0.95)"
            }
          />
        </Container>
        <Container display="inline">
          <Container
          // backgroundPosition={"0px -62px,0 19px,-20px -16px"}
          // backgroundImage={func.getStaticImg(
          //   "illustration/conference/shadow.svg"
          // )}
          // backgroundImage2={func.getStaticImg("bg/ribbon-banner.svg")}
          // backgroundImage3={func.getStaticImg("bg/shine-bg.svg")}
          >
            <PialaByuImg
              margin={
                isExtraSmallScreen
                  ? "-50px auto 0px auto"
                  : isSmallScreen
                    ? "20px auto 20px auto"
                    : "20px auto 20px auto"
              }
              src={func.getStaticImg("illustration/conference/kv-2026.png")}
              scale={
                isExtraSmallScreen
                  ? "scale(0.8)"
                  : isSmallScreen
                    ? "scale(0.95)"
                    : "scale(1)"
              }
              maxHeight={isMobileView ? "254px" : "425px"}
            />
          </Container>
        </Container>
        {/* {!!series && (
          <TitleCity
            src={func.getStaticImg("illustration/jawa-barat-title-banner.svg")}
          />
        )} */}
        {/* {!!series && <SeriesHeadline>{series}</SeriesHeadline>} */}
        {/* {currentDate.isBefore(startDate, "day") && !!regist_url ? (
          <Container
            justifyContent={"center"}
            display={"flex"}
            margin="0.5vh 0 0 0"
          >
            <CardRegister data={data} />
          </Container>
        ) :  */}
        <>
          <Container justifyContent={"center"} display={"flex"}>
            <Box
              onClick={() => {
                // handleBoxStep(0);
              }}
            >
              <Text
                color="white"
                size="small"
                weight="bold"
                removeGap
                style={{ fontSize: "1.6rem" }}
              >
                <ContainerHeadline>
                  {loc && (
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <img
                        src={func.getStaticImg(
                          "/illustration/pin-location.svg",
                        )}
                      />
                      <Headline>{loc}</Headline>
                    </div>
                  )}

                  {city && eventDate && (
                    <Headline>{`${city}, ${eventDate}`}</Headline>
                  )}
                </ContainerHeadline>
              </Text>
            </Box>
          </Container>

          <Container justifyContent={"center"} display={"flex"}>
            <JadwalKlasemenContainer>
              {isLive && (
                <Card
                  backgroundColor="white"
                  text="Nonton Live Streaming"
                  srcImg="/illustration/home-streaming.svg"
                  onClick={openLive}
                />
              )}
              <Card
                backgroundColor="white"
                text="Jadwal & Hasil Pertandingan"
                srcImg="/illustration/home-jadwal-v2.svg"
                onClick={() => {
                  analytics.sendEvent({
                    event: "subtab_pialabyu_click",
                    title: "Jadwal & Hasil Pertandingan",
                  });
                  navigate(`/${slug}/jadwal-pertandingan`);
                }}
              />
              {isLive && (
                <hr
                  style={{
                    flexBasis: "100%",
                    height: "0",
                    margin: "0",
                    border: "0",
                  }}
                />
              )}
              <Card
                backgroundColor="white"
                text="Klasemen & Statistik"
                srcImg="/illustration/home-klasemen-v2.svg"
                onClick={() => {
                  analytics.sendEvent({
                    event: "subtab_pialabyu_click",
                    title: "Klasemen & Statistik",
                  });
                  navigate(`/${slug}/klasemen-pertandingan`);
                }}
              />
              <Card
                backgroundColor="white"
                text="Info Kota Lainnya"
                srcImg="/illustration/icon-piala-byu-2026-card.svg"
                onClick={() => {
                  analytics.sendEvent({
                    event: "subtab_pialabyu_click",
                    title: "Info Kota Lainnya",
                  });
                  navigate(`/main`);
                }}
              />
            </JadwalKlasemenContainer>
          </Container>
        </>
      </>
    );
  };

  const DesktopBanner = () => {
    return (
      <Row style={{ maxWidth: "1440px", alignSelf: "center" }}>
        <Col md={6} style={{ display: "flex" }}>
          <PialaByuImg
            margin={"auto"}
            src={func.getStaticImg("illustration/conference/kv-2026.png")}
            maxHeight={"80vh"}
          />
        </Col>
        <Col md={6} lg={5}>
          <Container
            justifyContent={"center"}
            display={"flex"}
            flexDirection="column"
          >
            <TitleImg
              className={"mb-[3vh]"}
              marginTop={"12vh"}
              src={func.getStaticImg(
                "illustration/conference/headline-2026.png",
              )}
              alt="title"
              //maxWidth={"550px"}
              position="inherit"
              display="flex"
            />
            {/* {!!series && (
              <TitleCity
                src={func.getStaticImg(
                  "illustration/jawa-barat-title-banner.svg",
                )}
              />
            )} */}
            {/* {!!series && <SeriesHeadline>{series}</SeriesHeadline>} */}
            {/* {currentDate.isBefore(startDate, "day") && !!regist_url ? (
              <Container
                justifyContent={"center"}
                display={"flex"}
                margin="0.5vh 0 0 0"
              >
                <CardRegister data={data} />
              </Container>
            ) :  */}
            <>
              <Container
                justifyContent={"center"}
                display={"flex"}
                margin="0.5vh 0 0 0"
                className="min-w-[550px]"
              >
                <Box
                  onClick={() => {
                    // handleBoxStep(0);
                  }}
                >
                  <Text
                    color="white"
                    size="small"
                    weight="bold"
                    removeGap
                    style={{ fontSize: "1.6rem" }}
                  >
                    <ContainerHeadline>
                      {loc && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={func.getStaticImg(
                              isMobileView
                                ? "/illustration/pin-location.svg"
                                : "/illustration/pin-location-d.svg",
                            )}
                          />
                          <Headline>{loc}</Headline>
                        </div>
                      )}

                      {city && eventDate && (
                        <Headline>{`${city}, ${eventDate}`}</Headline>
                      )}
                    </ContainerHeadline>
                  </Text>
                </Box>
              </Container>

              <Container
                justifyContent={"center"}
                display={"flex"}
                margin="2.4vh 0 0 0"
              >
                <JadwalKlasemenContainer>
                  {isLive && (
                    <Card
                      backgroundColor="white"
                      text="Nonton Live Streaming"
                      srcImg="/illustration/home-streaming.svg"
                      onClick={openLive}
                    />
                  )}
                  <Card
                    backgroundColor="white"
                    text="Jadwal & Hasil Pertandingan"
                    srcImg="/illustration/home-jadwal-v2.svg"
                    onClick={() => {
                      analytics.sendEvent({
                        event: "subtab_pialabyu_click",
                        title: "Jadwal & Hasil Pertandingan",
                      });
                      navigate(`/${slug}/jadwal-pertandingan`);
                    }}
                  />
                  {isLive && (
                    <hr
                      style={{
                        flexBasis: "100%",
                        height: "0",
                        margin: "0",
                        border: "0",
                      }}
                    />
                  )}
                  <Card
                    backgroundColor="white"
                    text="Klasemen & Statistik"
                    srcImg="/illustration/home-klasemen-v2.svg"
                    onClick={() => {
                      analytics.sendEvent({
                        event: "subtab_pialabyu_click",
                        title: "Klasemen & Statistik",
                      });
                      navigate(`/${slug}/klasemen-pertandingan`);
                    }}
                  />
                  <Card
                    backgroundColor="white"
                    text="Info Kota Lainnya"
                    srcImg="/illustration/icon-piala-byu-2026-card.svg"
                    onClick={() => {
                      analytics.sendEvent({
                        event: "subtab_pialabyu_click",
                        title: "Info Kota Lainnya",
                      });
                      navigate(`/main`);
                    }}
                  />
                </JadwalKlasemenContainer>
              </Container>
            </>
            <Container justifyContent={"center"} display={"flex"}>
              <HintScroll onClick={handleScroll}>
                {"Scroll ke bawah"}
              </HintScroll>
            </Container>
            <Container justifyContent={"center"} display={"flex"}>
              <ScrollDownIcon
                onClick={handleScroll}
                alt="scroll-down"
                src={func.getStaticImg("icon/scroll-down.svg")}
              />
            </Container>
          </Container>
        </Col>
        <Col>
          {/* <Container
            justifyContent={"center"}
            display={"flex"}
            margin="-5vh 0 0 0"
          >
            <HintScroll onClick={handleScroll}>{"Scroll Ke bawah"}</HintScroll>
          </Container>
          <Container justifyContent={"center"} display={"flex"}>
            <ScrollDownIcon
              onClick={handleScroll}
              alt="scroll-down"
              src={func.getStaticImg("icon/scroll-down.svg")}
            />
          </Container> */}
        </Col>
      </Row>
    );
  };

  return (
    <BannerWrapper
      id="banner"
      // backgroundImage={func.getStaticImg(
      //   isMobileView
      //     ? "illustration/conference/backdrop.svg"
      //     : "illustration/conference/backdrop-desktop.svg"
      // )}
      zIndex={2}
      position="relative"
      backgroundColor="transparent"
      border={"1px transparent"}
      borderBottomLeftRadius={isMobileView ? "16px" : "0"}
      borderBottomRightRadius={isMobileView ? "16px" : "0"}
      // ponytail: min-height (not fixed height) lets the mobile hero grow with
      // its content instead of spilling over the section below on short phones.
      height={isMobileView ? "auto" : "100vh"}
      minHeight={isMobileView ? "100vh" : undefined}
      // ponytail: reserve the absolute navbar's footprint (top:25 + 64px) so the
      // headline never slides under it. `safe center` keeps centering on tall
      // phones but top-aligns below the header when content overflows a short one.
      paddingTop={isMobileView ? "80px" : undefined}
      justifyContent={isMobileView ? "safe center" : undefined}
    >
      {isMobileView ? <MobileBanner /> : <DesktopBanner />}

      <BottomSheet open={showChannels} onClose={() => setShowChannels(false)}>
        <div
          className="px-4 md:w-[588px] md:px-8"
          style={{
            paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 24px)",
          }}
        >
          <div className="relative flex items-center justify-center mb-4 md:mb-6">
            <h3 className="text-[18px] leading-[21px] font-bold text-[#1F2D3D] mt-4">
              Pilih Channel
            </h3>
            <button
              type="button"
              onClick={() => setShowChannels(false)}
              aria-label="Tutup"
              className="absolute right-0 p-1"
            >
              <img
                src={func.getStaticImg("icon/sa-close.svg")}
                alt=""
                className="w-8 h-8"
              />
            </button>
          </div>
          <div className="flex flex-col md:flex-row gap-3 md:gap-4 md:justify-center">
            {channels.map((c) => (
              <button
                key={c.name}
                type="button"
                onClick={() => watch(c.url)}
                aria-label={`Nonton di ${c.name}`}
                className="group w-full md:w-[194px] flex flex-col items-center gap-4 rounded-[24px] border-[1.5px] border-solid p-3 md:px-6 md:py-4 cursor-pointer transition-transform duration-150 hover:-translate-y-0.5"
                style={{
                  background: "linear-gradient(180deg,#FFFFFF 0%,#BCF0FF 100%)",
                  borderColor: "#00BCF1",
                  boxShadow:
                    "0 0 5px rgba(255,255,255,0.6), inset 0 0 6px rgba(255,255,255,0.35)",
                }}
              >
                <span className="inline-flex items-center rounded-[4px] px-1 py-0.5 text-[11px] leading-[13px] font-bold text-white whitespace-nowrap bg-[#AF183C]">
                  BERLANGSUNG
                </span>
                <img
                  src={func.getStaticImg(c.logo)}
                  alt={c.name}
                  className="h-[48px] max-w-full object-contain"
                />
                <span className="flex items-center justify-center h-[32px] px-4 rounded-[16px] bg-[#00BCF1] group-hover:bg-[#00A6D6] text-white text-[14px] leading-[19px] font-bold transition-colors w-auto md:w-full">
                  Nonton Disini
                </span>
              </button>
            ))}
          </div>
        </div>
      </BottomSheet>
    </BannerWrapper>
  );
};

export default BannerCity;
